export function isStringIn<T extends string>(str: string, subset: T[]): str is T {
    return subset.includes(str as T);
}

//Could potentially cause issues if obj includes properties that aren't part of the type
export function isKeyOf<T extends {}>(value: any, obj: T): value is keyof T {
    return !!obj[value as keyof T];
}
